module.exports = "<p>\r\n  page-not-found works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/components/page-not-found/page-not-found.component.html
// module chunks = main